import React, {useEffect, useRef} from 'react';
import Config from '../../../../../../Config';
import PopUp from '../../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import {getEsimTypeCode, isEsimType, isSimType} from '../../../../../../utilities/domain/simTypeConstants';

const ChooseSimType = (props) => {
  const ref = useRef(null);
  const whatIsEsimPopupTextList = props.esimData?.whatIsEsimPopupText?.value;
  const isDeviceSupportEsimPopupText = props.esimData?.isDeviceSupportEsimPopupText?.value;
  const url = props.esimData?.cellularDevicesSupportedUrl?.value;
  const esimSupportText = props.esimData?.esimSupportText?.value;
  const esimTaG = props.esimData?.esimTag?.value;

  useEffect(() => {
    if (!props.isDisable) {
      if (ref.current) {
        const offsetTop = ref.current.offsetTop;
        window.scrollTo({top: offsetTop, behavior: 'smooth'});
      }
    }
  }, [props.isDisable]);

  const price = (price) => {
    if (price) {
      if (price == '' || price == '0' || price == '0.00') {
        return (
          <div className='left-details'>
            <div className='price'>ללא עלות</div>
            <div className='text'></div>
          </div>
        );
      } else {
        return (
          <div className='left-details'>
            <div className='price'>₪{price}</div>
            <div className='text'>עלות חד פעמית</div>
          </div>
        );
      }
    }
  };

  function displayIsMyPhoneSupportEsimPoUp(){
    props.toggleEsimPopUp(false, false);
    props.toggleIsMyDeviceSupportESIMPopUp(true);
  }

  return (
    <div ref={ref} className={`choosing-sim-type ${props.isDisable ? 'disabled' : ''}`}>
      {props.isDisable && <div className='disabled'></div>}
      <h2 className='title'>איזה סוג SIM תרצו?</h2>
      <div className='sim-type-wrapper'>
        <button
          className={isSimType(props.simType) ? 'isSelected' : ''}
          onClick={() => {
            props.onSelectedSimType('SIM');
          }}>
          <div className='details'>
            <div className='right-details'>
              <div className='title'>SIM רגיל</div>
            </div>
            {price(props.simPrice?.sim)}
          </div>
        </button>
        <button
          className={isEsimType(props.simType) ? 'isSelected' : ''}
          onClick={() => {
            props.onSelectedSimType(getEsimTypeCode());
          }}>
          {esimTaG && <span className='label'>{esimTaG}</span>}
          <div className='details'>
            <div className='right-details'>
              <div className='title'>eSIM</div>
            </div>
            {price(props.simPrice?.esim)}
          </div>
        </button>
      </div>
      {esimSupportText && <div className='esim-text'>{esimSupportText}</div>}
      <button
        className='open-popup-btn'
        onClick={() => {
          props.toggleEsimPopUp(true);
        }}>
        מה זה eSIM?
      </button>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          props.toggleIsMyDeviceSupportESIMPopUp(true);
        }}>
        האם המכשיר שלי תומך ב-eSIM?
      </a>
      <PopUp showPopUp={props.showEsimPopUp} onClose={() => props.toggleEsimPopUp(false, false)} className='popup-esim-details'>
        <h1>מה זה eSIM?</h1>
        <div className='esim-description-text' dangerouslySetInnerHTML={{__html: whatIsEsimPopupTextList}}></div>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            displayIsMyPhoneSupportEsimPoUp();
          }}>
          האם המכשיר שלי תומך ב-eSIM?
        </a>
        <BtnSubmit
          isBusiness={false}
          text={'הבנתי, תודה'}
          onclick={() => {
            props.toggleEsimPopUp(false, true);
          }}
          formid={'popup-esim-details'}
          isDisplayArrows={false}
        />
      </PopUp>
      <PopUp showPopUp={props.showIsMyDeviceSupportESIMPopUp} onClose={() => props.toggleIsMyDeviceSupportESIMPopUp(false, false)} className='popup-is-my-device-support-esim'>
        <h1>בואו נבדוק אם המכשיר<br/> שלך תומך</h1>
        <div className='esim-description-text' dangerouslySetInnerHTML={{__html: isDeviceSupportEsimPopupText}}></div>
        <BtnSubmit
          isBusiness={false}
          text={'הבנתי, תודה'}
          onclick={() => {
            props.toggleIsMyDeviceSupportESIMPopUp(false, true);
          }}
          formid={'popup-esim-details'}
          isDisplayArrows={false}
        />
      </PopUp>
    </div>
  );
};

export default ChooseSimType;
